export default __webpack_public_path__ + "static/media/PanetelaClosed.bb06be3c.jpg";